interface ISvgInfoProps {
    height: number | string;
    width: number | string;
    color: string;
}

const SvgInfo: React.FC<ISvgInfoProps> = (props) => {
    return (
        <svg width={props.width} height={props.height} viewBox="0 0 60 61" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M27.5 43H32.5V28H27.5V43ZM30 5.5C16.2 5.5 5 16.7 5 30.5C5 44.3 16.2 55.5 30 55.5C43.8 55.5 55 44.3 55 30.5C55 16.7 43.8 5.5 30 5.5ZM30 50.5C18.975 50.5 10 41.525 10 30.5C10 19.475 18.975 10.5 30 10.5C41.025 10.5 50 19.475 50 30.5C50 41.525 41.025 50.5 30 50.5ZM27.5 23H32.5V18H27.5V23Z"
                fill={props.color}
            />
        </svg>
    );
};

export default SvgInfo;
